import React, { forwardRef } from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HomeIcon from '@mui/icons-material/Home';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AvTimerIcon from '@mui/icons-material/AvTimer';

const useStyles = makeStyles({
    stickToBottom: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        background: '#efefef'
    },
});

const FooterMenu = forwardRef((props, ref) => {
    const pathname = window.location.pathname;
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <footer>
            <BottomNavigation
                value={pathname}
                style={{zIndex: 999, height: '75px'}}
                showLabels
                className={classes.stickToBottom}>
                <BottomNavigationAction label={t('menu.home')}
                                        icon={<HomeIcon />}
                                        component={Link}
                                        to="/home"
                                        value="/home"/>
                <BottomNavigationAction label={t('menu.ordering')}
                                        icon={<AvTimerIcon />}
                                        component={Link}
                                        to='/orders'
                                        value='/orders' />
                <BottomNavigationAction label={t('menu.shop')}
                                        icon={<StorefrontIcon />}
                                        component={Link}
                                        to="/shops"
                                        value="/shops"/>
            </BottomNavigation>
        </footer>
    )
});

export default FooterMenu;